import { Button, Form, Input, Modal } from 'antd';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { useStateContext } from '~/contexts/ContextProvider';
import { instanceAuth } from '~/utils/axios';
import { useTranslation } from 'react-i18next';
import { NS } from '~/utils/ns';
const ModalPasswordV2 = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation([NS['profile']]);
  const { agency, setAgency } = useStateContext();
  const [isOpen, setIsOpen] = useState(false);
  const handleCancel = () => {
    setIsOpen(false);
  };
  const handleSubmit = async (data) => {
    try {
      setIsLoading(true);
      const res = await instanceAuth().post('/change-password-v2', data);
      if (res.status) {
        toast.success(t('doimkthanhcong'));
        const reload = await instanceAuth().get('/check');
        if (reload?.result?.status) {
          setAgency(reload?.result?.data);
        }
        handleCancel();
      } else {
        toast.error(t('saimk'));
      }
    } catch (error) {
      console.log(error, 'error nè');
      toast.error(t('common:45'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Button className="bg-blue-500 text-white" onClick={() => setIsOpen(true)}>
        {t('change')}
      </Button>
      <Modal open={isOpen} onOk={handleCancel} onCancel={handleCancel} footer={null}>
        <h3 className="font-semibold text-xl text-center">{t('doimkruttien')}</h3>
        <Form layout="vertical" onFinish={handleSubmit}>
          {agency?.password_v2 && (
            <Form.Item
              label={t('matkhaudangnhap')}
              name="oldPassword"
              required
              rules={[{ required: true, message: t('vuilongnhapmkdangnhap') }]}>
              <Input.Password placeholder={t('nhapmkdangnhap')} />
            </Form.Item>
          )}

          <Form.Item
            label={t('newPassword')}
            name="newPassword"
            required
            rules={[{ required: true, message: t('vuilongnhapmkmoi') }]}>
            <Input.Password placeholder={t('nhapmkmoi')} />
          </Form.Item>
          <Form.Item
            label={t('xacnhanmkmoi')}
            name="rePassword"
            required
            rules={[
              {
                required: true,
                message: t('vuilongnhapmkxacnhan'),
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t('mkxacnhanktrung')));
                },
              }),
            ]}>
            <Input.Password placeholder={t('nhapmkxacnhan')} />
          </Form.Item>
          <div className="flex justify-end gap-3">
            <Button onClick={handleCancel}>{t('common:cancel')}</Button>
            <Button className="bg-blue-500 text-white" htmlType="submit" loading={isLoading}>
              {t('doimk')}
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default ModalPasswordV2;
